export enum NotificationCloseHandlerType {
    Reload = 'Reload',
    Init = 'Init',
    UnauthenticatedExit = 'UnathenticatedExit',
    NetworkLossExit = 'NetworkLossExit',
    UserAccountDeletedExit = 'UserAccountDeletedExit',
}
